(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scc-engraving-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scc-engraving-preview')) {
    customElements.define('scc-engraving-preview', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        const initialize = () => {
          const field = this.parentElement?.querySelector('textarea[name="properties[Name Engraving]"]');
          const nameNode = this.querySelector('.scc-live-engraving__name');
          const parts = ['stage', 'reference', 'reference-name', 'empty', 'long'];
          if (!field || !nameNode || parts.some(part => !this.querySelector('.scc-live-engraving__' + part))) return false;
          this.field = field;
          this.nameNode = nameNode;
          this.controller = new AbortController();
          this.renderName = () => {
            const value = this.field.value;
            this.querySelector('.scc-live-engraving__stage').hidden = false;
            this.nameNode.textContent = value;
            let measured;
            try { measured = this.nameNode.getComputedTextLength(); }
            catch { measured = Infinity; }
            const isLong = value.length > 0 && (!Number.isFinite(measured) || measured > 130);
            this.nameNode.textContent = isLong ? '' : value;
            this.querySelector('.scc-live-engraving__stage').hidden = isLong;
            this.querySelector('.scc-live-engraving__reference').hidden = !isLong;
            this.querySelector('.scc-live-engraving__reference-name').textContent = value;
            this.querySelector('.scc-live-engraving__empty').hidden = value.length > 0;
            this.querySelector('.scc-live-engraving__long').hidden = !isLong;
            this.dataset.previewState = isLong ? 'text-reference' : value.length ? 'engraving' : 'empty';
          };
          this.field.addEventListener('input', this.renderName, { signal: this.controller.signal });
          this.field.addEventListener('change', this.renderName, { signal: this.controller.signal });
          this.closest('form')?.addEventListener('reset', () => requestAnimationFrame(this.renderName), { signal: this.controller.signal });
          this.renderName();
          document.fonts?.ready.then(() => { if (this.isConnected) this.renderName(); });
          return true;
        };
        if (!initialize() && this.parentElement) {
          this.observer = new MutationObserver(() => {
            if (initialize()) this.observer.disconnect();
          });
          this.observer.observe(this.parentElement, { childList: true, subtree: true });
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
